/**
 * Public spectator routes — no analytics, no cookie consent.
 *
 * Its own module (it used to be private to App.jsx) so a test can hold it
 * against the boot script's route classification: every path that
 * `window.__sendlyPathKind()` in index.html calls an unattended surface
 * ('kiosk' / 'spectator' / 'embed') must match this pattern too, or an
 * unattended display would run analytics without a consent flow
 * (apps/web/src/__tests__/pathKind.test.js).
 */
export const PUBLIC_DASHBOARD_RE = /^\/gym\/[^/]+\/(dashboard|competition\/[^/]+\/(tv|register)|competition\/[^/]+|event\/[^/]+\/register|series\/[^/]+)$|^\/embed\/[^/]+\/[^/]+$/;
